import authTokenHandler from '@/utils/authTokenHandler';

const tokenService = {
  /**
   * Attempts to refresh the access token using the stored refresh token.
   * @returns {Promise<void>} A promise that resolves if token refresh and
   * storage succeed.
   */
  async refreshToken(axiosInstance) {
    return authTokenHandler.retrieveToken().then((tokenData) => {
      console.log('refreshToken');
      if (!tokenData.refresh_token) {
        throw new Error('No refresh token available');
      }
      return axiosInstance
        .post('/oauth/token', {
          grant_type: 'refresh_token',
          refresh_token: tokenData.refresh_token
        })
        .then(this.handleTokenResponse);
    });
  },

  /**
   * Handles the response from the OAuth server, updating the stored tokens.
   * @param {Object} response - The response from the OAuth server.
   * @returns {Promise<void>} A promise that resolves when tokens are stored.
   */
  handleTokenResponse(response) {
    if (!response.data.access_token) {
      throw new Error('No access token received');
    }
    const tokenData = {
      access_token: response.data.access_token,
      refresh_token: response.data.refresh_token,
      expires_at: Math.floor(Date.now() / 1000) + response.data.expires_in
    };
    return authTokenHandler.storeToken(tokenData);
  }
};

export default tokenService;
